import "./overlay.scss";

import { Instructions } from "@amzn/itsvideo-recorder/lib/VideoRecorder";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import {
  IconCheckCircleFillLarge,
  IconCheckCircleFillMedium,
} from "@amzn/stencil-react-icons";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";

import IDSvg from "./id.svg";
import PersonSvg from "./person.svg";

interface OverlayProps {
  shown: boolean;
}

export const IDOverlay = (props: OverlayProps) => {
  return (
    <div
      className={`video-overlay video-overlay__id ${
        props.shown ? " animate" : ""
      }`}
    >
      <img src={IDSvg} alt="" />
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
export const PersonOverlay = (props: OverlayProps) => {
  return (
    <div className="video-overlay video-overlay__person">
      <img src={PersonSvg} alt="" />
    </div>
  );
};

export const VideoOverlay = [
  {
    component: PersonOverlay,
    timeToShowMs: 500,
    timeToHideMs: 4000,
    transitionTimeMs: 1000,
  },
  {
    component: IDOverlay,
    timeToShowMs: 5000,
    timeToHideMs: 14000,
    transitionTimeMs: 1000,
  },
];

const gestureCaptured = (gestureCount: number) => {
  return function GestureOverlay(props: OverlayProps) {
    return (
      <div className="video-overlay__container">
        <div className="video-overlay__inner">
          <Col gridGap={"S200"} alignItems="center">
            <Text fontWeight={700}>
              <FormattedMessage
                id="identityCheck-video-gesture-captured"
                values={{
                  gesture: gestureCount,
                }}
              />
            </Text>
            <IconCheckCircleFillLarge color="color.status.success-icon" />
          </Col>
        </div>
      </div>
    );
  };
};

const GesturesComplete = (props: OverlayProps) => {
  return (
    <div className="video-overlay__container">
      <div className="video-overlay__inner video-overlay__complete">
        <Col gridGap={"S200"} alignItems="center">
          <Row alignItems="center" gridGap={"S200"}>
            <IconCheckCircleFillMedium
              color="white"
              enableBackground={"green70"}
            />
            <Text fontWeight={700}>
              <FormattedMessage id="identityCheck-video-gesture-complete" />
            </Text>
          </Row>
        </Col>
      </div>
    </div>
  );
};

export const CompletedGesturesOverlay = [gestureCaptured(1), GesturesComplete];

export const gestureOverlay = (instruction: Instructions) => {
  return function GestureOverlay(props: OverlayProps) {
    const [seconds, setSecondsRemaining] = useState(5);
    const [counting, setCounting] = useState(false);
    const timeout = useRef<ReturnType<typeof setTimeout>>();
    useEffect(() => {
      const countdown = (current: number) => {
        if (current === 0) {
          return;
        }
        setSecondsRemaining(current - 1);
        timeout.current = setTimeout(() => countdown(current - 1), 1000);
      };
      if (props.shown && !counting) {
        countdown(6);
        setCounting(true);
      }
      return () => {
        if (timeout.current) {
          clearTimeout(timeout.current);
        }
      };
    }, [props.shown]);
    return (
      <div className="video-overlay__container">
        <div className="video-overlay__inner">
          <Col gridGap={"S200"} alignItems="center">
            <Text fontWeight={700}>{instruction.text}</Text>
            <Text fontWeight={400}>
              <FormattedMessage
                id="identityCheck-video-overlay-countdown"
                values={{
                  seconds,
                }}
              />
            </Text>
          </Col>
        </div>
      </div>
    );
  };
};
